<template>
  <div class="d-flex w-100">
    <div class="d-flex w-100">
      <div class="col-md-3">
        <inqueryFilter @search="search"></inqueryFilter>
      </div>
      <div class="col-md-9">
        <!-- <inqueryTable ref="registerTable" @detalhesDespesa="detalhesApr"></inqueryTable> -->
        <inqueryTable ref="registerTable"></inqueryTable>
      </div>
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import inqueryFilter from '@/views/private/apr/inqueryApr/components/inqueryFilter/inqueryFilter'
import inqueryTable from '@/views/private/apr/inqueryApr/components/inqueryTable/inqueryTable'
// import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'templateFilter',
  components: {Multiselect, inqueryFilter, inqueryTable},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
    }
  },
  mounted () {
    // this.getAllCategories()
  },
  methods: {
    search (data) {
      this.$refs.registerTable.formSearch = data
      this.$refs.registerTable.onLoad()
    }
    // onClearSection () {
    //   this.forms.listagemInterna = null
    //   this.forms.descricao = null
    // }
  }
}

</script>

<style scoped>
.col-md-3{
padding-right: 0;
padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/inqueryApr.vue